import React from 'react'
import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  message?: string // Alternative to description for backward compatibility
  action?: {
    label: string
    onClick: () => void
  }
  className?: string
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  icon: Icon,
  title,
  description,
  message,
  action,
  className
}) => {
  // Use message if description is not provided (backward compatibility)
  const descriptionText = description || message
  
  return (
    <div className={cn(
      'text-center py-12 bg-gray-50 dark:bg-gray-800/50 rounded-lg',
      className
    )}>
      {Icon && (
        <div className="mx-auto w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4">
          <Icon className="w-8 h-8 text-gray-400 dark:text-gray-500" />
        </div>
      )}
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
        {title}
      </h3>
      {descriptionText && (
        <p className="text-gray-500 dark:text-gray-400 mb-4 max-w-md mx-auto">
          {descriptionText}
        </p>
      )}
      {action && (
        <button
          onClick={action.onClick}
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}

export default EmptyState
